import { render, staticRenderFns } from "./PrivacyAndPolicy.vue?vue&type=template&id=576dacb9&scoped=true"
import script from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyAndPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAndPolicy.vue?vue&type=style&index=0&id=576dacb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576dacb9",
  null
  
)

export default component.exports